import React from 'react';

interface EvoWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export const EvoWrapper: React.FC<EvoWrapperProps> = ({ children, className = '' }) => {
  return (
    <div className={`evo-wrapper ${className}`.trim()}>
      {children}
    </div>
  );
};

export default EvoWrapper;
